import React, { useState, ChangeEvent, useEffect, useRef } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import { CircularProgress } from '@mui/material';
import Text from '../text';
import { ProgressBar } from './ProgressBar';

interface FirmwareSpinnerProps {
    open: boolean;
    onClose: () => void;
    onConfirm: () => void;
    percent: number;
}

const FirmwareSpinner: React.FC<FirmwareSpinnerProps> = ({
    open,
    onClose,
    onConfirm,
    percent
}) => {

    function determineLabel(): string {
        if (percent === 0) {
            return "Preparing";
        } else if (percent < 100) {
            return "Installing on analyzer";
        } else {
            return "Restarting analyzer";
        }
    }

    return (
        <Dialog
            open={open}
            onClose={(event, reason) => {
                if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
                    return;
                }
                onClose();
            }}
            disableEscapeKeyDown={true}
            maxWidth="md"
            id="firmware-spinner-dialog"
        >
            <DialogContent>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                    <Text addStyle="!text-[#2C2C2C] !font-inter !text-[16px] !font-bold">
                        Firmware update in progress.
                    </Text>
                    <Text addStyle="!text-[#2C2C2C] !font-inter !text-[16px]">
                        Please do not disconnect your device.
                    </Text>
                    <Text addStyle="!text-[#2C2C2C] !font-inter !text-[16px]">
                        This may take up to 10 minutes.
                    </Text>
                    <ProgressBar
                        percent={percent}
                        label={determineLabel()}
                    />
                </div>
            </DialogContent>
        </Dialog>
    );
};

export default FirmwareSpinner;
